/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AvailableServiceBreakLocationsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type AvailableServiceBreakLocationsQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      available: boolean
      name: string
      type: Types.ServiceBreakLocationType
      polygon: string | null
      routableLocation: {
        __typename?: 'LocationWithHeading'
        latitude: number
        longitude: number
        heading: number
      } | null
    }>
  }
}

export const AvailableServiceBreakLocationsDocument = gql`
    query availableServiceBreakLocations($regionId: ID!) {
  serviceBreakLocations(input: {regionId: $regionId, filters: {states: [ACTIVE]}}) {
    serviceBreakLocations {
      id
      available
      name
      type
      polygon
      routableLocation {
        latitude
        longitude
        heading
      }
    }
  }
}
    `

/**
 * __useAvailableServiceBreakLocationsQuery__
 *
 * To run a query within a React component, call `useAvailableServiceBreakLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableServiceBreakLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableServiceBreakLocationsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAvailableServiceBreakLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AvailableServiceBreakLocationsQuery,
    AvailableServiceBreakLocationsQueryVariables
  > &
    (
      | {
          variables: AvailableServiceBreakLocationsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AvailableServiceBreakLocationsQuery,
    AvailableServiceBreakLocationsQueryVariables
  >(AvailableServiceBreakLocationsDocument, options)
}
export function useAvailableServiceBreakLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableServiceBreakLocationsQuery,
    AvailableServiceBreakLocationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AvailableServiceBreakLocationsQuery,
    AvailableServiceBreakLocationsQueryVariables
  >(AvailableServiceBreakLocationsDocument, options)
}
// @ts-ignore
export function useAvailableServiceBreakLocationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableServiceBreakLocationsQuery,
    AvailableServiceBreakLocationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AvailableServiceBreakLocationsQuery,
  AvailableServiceBreakLocationsQueryVariables
>
export function useAvailableServiceBreakLocationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableServiceBreakLocationsQuery,
        AvailableServiceBreakLocationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AvailableServiceBreakLocationsQuery | undefined,
  AvailableServiceBreakLocationsQueryVariables
>
export function useAvailableServiceBreakLocationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableServiceBreakLocationsQuery,
        AvailableServiceBreakLocationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AvailableServiceBreakLocationsQuery,
    AvailableServiceBreakLocationsQueryVariables
  >(AvailableServiceBreakLocationsDocument, options)
}
export type AvailableServiceBreakLocationsQueryHookResult = ReturnType<
  typeof useAvailableServiceBreakLocationsQuery
>
export type AvailableServiceBreakLocationsLazyQueryHookResult = ReturnType<
  typeof useAvailableServiceBreakLocationsLazyQuery
>
export type AvailableServiceBreakLocationsSuspenseQueryHookResult = ReturnType<
  typeof useAvailableServiceBreakLocationsSuspenseQuery
>
export type AvailableServiceBreakLocationsQueryResult = Apollo.QueryResult<
  AvailableServiceBreakLocationsQuery,
  AvailableServiceBreakLocationsQueryVariables
>
